import Image from "next/image";

import planeIcon from "@repo/ui/assets/extras/flight.svg";
import { formatTravelHeader } from "@repo/ui/helpers/Extras/formatTravelHeader";

import { useAppSelector } from "@repo/store/hooks";
import { useBookingDetails } from "@repo/store/slices";

type FlightRouteHeaderProps = {
  direction?: string;
  directionLabel?: string;
};

export default function FlightRouteHeader({
  direction,
  directionLabel,
}: Readonly<FlightRouteHeaderProps>) {
  const bookingDetails = useBookingDetails();
  const stations = useAppSelector((state) => state.stations?.stations);

  if (!bookingDetails) {
    return null;
  }

  const headerLocations = formatTravelHeader(bookingDetails, direction, stations);

  return (
    <div className="text-brand-blue flex flex-wrap items-center text-sm">
      <span className="text-brand-red mr-2 font-semibold uppercase">{directionLabel}</span>
      <span className="mr-1">-</span>
      <span>{headerLocations.headerOrigin}</span>
      <Image src={planeIcon} width={25} height={25} alt="plane icon" className="mx-2" />
      <span>{headerLocations.headerDestination}</span>
    </div>
  );
}
